import styled, { css, keyframes } from 'styled-components';
import { media } from 'components/styles';

// Import styles
import { modalFadeInUp } from 'components/styles';

// Import icons
import { ReactComponent as IconClose } from 'assets/icons/ic_close_thin.svg';

// Import components
import { Button } from 'components/elements';

export const Wrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	z-index: 1000;
`;

export const MobileWrapper = styled.section`
	position: fixed;
	overflow: hidden auto;
	inset: 0;
	width: 100vw;
	height: 100%;
	min-height: 100vh;
	background-color: ${({ theme }) => theme.blackPearl};
	padding: 5rem 0;
	z-index: 1000;
`;

export const Bg = styled.div`
	position: fixed;
	inset: 0;
	height: 100%;
	width: 100%;
	background-color: ${({ theme }) => theme.payment.bgColor};
	z-index: -1;
`;

export const GradientBox = styled.div`
	position: absolute;
	top: 6rem;
	left: 50%;
	transform: translateX(-50%);
	width: 90%;
	background: linear-gradient(
		205deg,
		${({ theme }) => theme.payment.gradientBox.color1} 12%,
		${({ theme }) => theme.payment.gradientBox.color2} 75%
	);
	padding: 0.1rem;
	border-radius: 0.6rem;
	margin: 3rem 0;
	opacity: 0;
	animation: ${modalFadeInUp} 0.3s ease-in-out forwards;
	${media.min.medium(css`
		width: 80%;
	`)};
`;

export const Box = styled.div`
	position: relative;
	border-radius: 0.6rem;
	background: ${({ theme }) => theme.black};
	overflow: hidden;
`;

export const ButtonClose = styled(Button)`
	position: absolute;
	top: 2rem;
	right: 2rem;
	z-index: 10;
	color: ${({ theme }) => theme.white};
`;

export const IconCloseStyled = styled(IconClose).attrs(({ height, width }) => ({
	style: { height: height || '1.3rem', width: width || '1.3rem' }
}))`
	position: relative;
	z-index: 10;
	padding: 0;
`;

export const Content = styled.div`
	position: relative;
	padding-top: 3rem;
`;

export const GradientRadial = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	background: radial-gradient(
		ellipse at center,
		${({ theme }) => theme.payment.gradientRadial.color1} 12%,
		${({ theme }) => theme.payment.gradientRadial.color2} 97%
	);

	${({ isPacket }) =>
		isPacket &&
		css`
			top: 0;
		`}
`;

export const BlackTransparentBackground = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	background: ${({ theme }) => theme.blackSemiTranslucent};
	z-index: ${({ zIndex }) => zIndex};
`;

export const alertFadeInUp = keyframes`
    0% {
        opacity: 0;
        top: calc(50% + 10rem);
    }
    100% {
        opacity: 1;
        top: 50%;
    }
`;

export const GradientBoxStyled = styled(GradientBox)`
	top: 50%;
	transform: translate3d(-50%, -50%, 0);
	max-width: 70rem;
	height: ${({ modalHeight }) => (modalHeight ? modalHeight + 'rem' : 'auto')};
	margin: 0;
	animation: ${alertFadeInUp} 0.3s ease-in-out forwards;
`;

export const BoxStyled = styled(Box)`
	height: 100%;
	background: transparent;
`;

export const GradientRadialStyled = styled(GradientRadial)`
	background: radial-gradient(
		ellipse at center,
		${({ theme }) => theme.payment.gradientRadial.color1} 12%,
		${({ theme }) => theme.payment.gradientRadial.color2} 93%
	);
`;

export const ContentStyled = styled(Content)`
	padding: 2rem;
	${media.min.xmin(css`
		padding: 5.2rem 6.5rem 4.5rem;
	`)}
`;
